import React, { useState, useCallback } from 'react';
import { Upload, FileText, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { base44 } from '@/api/base44Client';

export default function FileUploadZone({ contextType = 'General', parentContextId = null, onUploadComplete }) {
  const [isDragging, setIsDragging] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState('');

  const handleDragOver = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  }, []);

  const handleDragLeave = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  }, []);

  const handleDrop = useCallback(async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);

    const files = Array.from(e.dataTransfer.files);
    if (files.length > 0) {
      await uploadFiles(files);
    }
  }, [contextType, parentContextId]);

  const handleFileSelect = async (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 0) {
      await uploadFiles(files);
    }
  };

  const uploadFiles = async (files) => {
    setIsUploading(true);

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      setUploadProgress(`Uploading ${file.name} (${i + 1}/${files.length})...`);

      try {
        await base44.functions.invoke('uploadToGoogleDrive', {
          file: file,
          context_type: contextType,
          parent_context_id: parentContextId || null
        });
      } catch (error) {
        console.error('Upload error:', error);
        alert(`Failed to upload ${file.name}: ${error.message}`);
      }
    }

    setIsUploading(false);
    setUploadProgress('');

    if (onUploadComplete) {
      onUploadComplete();
    }
  };

  return (
    <div className="space-y-3">
      <div
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop} className="bg-slate-50 p-8 text-center rounded-lg border-2 border-dashed transition-colors cursor-pointer border-slate-700 hover:border-slate-600">






        {isUploading ?
        <div className="flex flex-col items-center gap-3">
            <Loader2 className="w-8 h-8 text-indigo-400 animate-spin" />
            <p className="text-sm text-slate-400">{uploadProgress}</p>
          </div> :

        <div className="flex flex-col items-center gap-3">
            <Upload className="w-8 h-8 text-slate-400" />
            <div>
              <p className="text-slate-500 mb-1">Drag and drop files here</p>
              <p className="text-sm text-slate-500">or</p>
            </div>
            <Button
            onClick={() => document.getElementById('file-input').click()}
            className="bg-indigo-600 hover:bg-indigo-700">

              <FileText className="w-4 h-4 mr-2" />
              Select Files
            </Button>
            <input data-testid="doclib-fileuploadzone-input"
            id="file-input"
            type="file"
            multiple
            onChange={handleFileSelect}
            className="hidden" />

          </div>
        }
      </div>
    </div>);

}